import _ from 'lodash';
import {
  humanNamePrefixOptionsOptionsList,
  humanNameSuffixOptionsList,
  patientGenderOptionsList,
  usaStateListWithCodes,
} from '../../data/fhirHumanNameData';

export const practitionerInitailStateFhirJson = (data, selectedVersion) => {
  let genderDisplay =
    patientGenderOptionsList?.[
      _.findIndex(patientGenderOptionsList, o => o?.code === data?.gender)
    ]?.display;

  let qualificationFind =
    data?.qualification &&
    data?.qualification.find(
      f =>
        f?.code?.coding?.[0]?.system ===
        'http://terminology.hl7.org/CodeSystem/v2-0360/2.7'
    );
  let version1Value;
  let version1Name;
  if (selectedVersion === 'IN') {
    version1Value =
      data?.identifier?.[
        _.findIndex(
          data?.identifier,
          o => o?.type?.coding?.[0].code === 'AADHAAR'
        )
      ]?.value;
    version1Name = 'aadhaar';
  } else if (
    _.isUndefined(
      data?.identifier?.find(o => o?.type?.coding?.[0].code === 'SS')
    )
  ) {
    version1Value =
      data?.identifier?.[
        _.findIndex(
          data?.identifier,
          o => o?.type?.coding?.[0].code === 'AADHAAR'
        )
      ]?.value;
    version1Name = 'aadhaar';
  } else {
    version1Value =
      data?.identifier?.[
        _.findIndex(data?.identifier, o => o?.type?.coding?.[0].code === 'SS')
      ]?.value;
    version1Name = 'ssn';
  }

  let version2Value;
  let version2Name;

  if (selectedVersion === 'IN') {
    version2Value =
      data?.identifier?.[
        _.findIndex(data?.identifier, o => o?.type?.coding?.[0].code === 'NMC')
      ]?.value;
    version2Name = 'nmc';
  } else if (
    _.isUndefined(
      data?.identifier?.find(o => o?.type?.coding?.[0].code === 'NPI')
    )
  ) {
    version2Value =
      data?.identifier?.[
        _.findIndex(data?.identifier, o => o?.type?.coding?.[0].code === 'NMC')
      ]?.value;
    version2Name = 'nmc';
  } else {
    version2Value =
      data?.identifier?.[
        _.findIndex(data?.identifier, o => o?.type?.coding?.[0].code === 'NPI')
      ]?.value;
    version2Name = 'npi';
  }

  return {
    id: data?.id,
    resourceType: data?.resourceType,
    name: data?.name,
    gender: !_.isUndefined(data?.gender)
      ? data?.gender
      : patientGenderOptionsList?.[0]?.code,
    genderDisplay: !_.isUndefined(genderDisplay) ? genderDisplay : '',
    birthDate: data?.birthDate,
    telecom: data?.telecom,
    address: data?.address,
    identifier: data?.identifier,
    managingOrganizationObject: {
      code: data?.managingOrganization?.reference,
    },
    [version1Name]: version1Value,
    [version2Name]: version2Value,
    active: !_.isUndefined(data?.active) ? data?.active : true,
    qualificationObject: {
      code: !_.isUndefined(qualificationFind)
        ? qualificationFind?.code?.coding?.[0]?.code
        : '',
      display: !_.isUndefined(qualificationFind)
        ? qualificationFind?.code?.coding?.[0]?.display
        : '',
    },
  };
};

export const patientInitailStateFhirJson = (data, selectedVersion) => {
  let genderDisplay =
    patientGenderOptionsList?.[
      _.findIndex(patientGenderOptionsList, o => o?.code === data?.gender)
    ]?.display;
  let version1Value;
  let version1Name;

  if (selectedVersion === 'IN') {
    version1Value =
      data?.identifier?.[
        _.findIndex(
          data?.identifier,
          o => o?.type?.coding?.[0].code === 'AADHAAR'
        )
      ]?.value;
    version1Name = 'aadhaar';
  } else if (
    _.isUndefined(
      data?.identifier?.find(o => o?.type?.coding?.[0].code === 'SS')
    )
  ) {
    version1Value =
      data?.identifier?.[
        _.findIndex(
          data?.identifier,
          o => o?.type?.coding?.[0].code === 'AADHAAR'
        )
      ]?.value;
    version1Name = 'aadhaar';
  } else {
    version1Value =
      data?.identifier?.[
        _.findIndex(data?.identifier, o => o?.type?.coding?.[0].code === 'SS')
      ]?.value;
    version1Name = 'ssn';
  }

  return {
    id: data?.id,
    resourceType: data?.resourceType,
    name: data?.name,
    gender: !_.isUndefined(data?.gender)
      ? data?.gender
      : patientGenderOptionsList?.[0]?.code,
    genderDisplay: !_.isUndefined(genderDisplay) ? genderDisplay : '',
    birthDate: data?.birthDate,
    telecom: data?.telecom,
    address: data?.address,
    identifier: data?.identifier,
    managingOrganizationObject: {
      code: data?.managingOrganization?.reference,
    },
    primaryCareObject: {
      code: data?.generalPractitioner?.[0]?.reference,
    },
    generalPractitionerObject: {
      code: data?.generalPractitioner?.[1]?.reference,
    },
    [version1Name]: version1Value,
    active: !_.isUndefined(data?.active) ? data?.active : true,
  };
};

export const humanNameInitalFromFhirPatientObject = humanNameObject => {
  if (!_.isEmpty(humanNameObject)) {
    return {
      use: humanNameObject?.use, // usual | official | temp | nickname | anonymous | old | maiden
      text: !_.isUndefined(humanNameObject?.text) ? humanNameObject?.text : '', // Text representation of the full name
      family: !_.isUndefined(humanNameObject?.family)
        ? humanNameObject?.family
        : '', // Family name (often called 'Surname')
      given: humanNameObject?.given, // Given names (not always 'first'). Includes middle names//array
      prefixArray: humanNameObject?.prefix, // Parts that come before the name//array
      suffixArray: humanNameObject?.suffix, // Parts that come after the name//array
      period: humanNameObject?.period, // Time period when name was/is in use
      firstName: !_.isUndefined(humanNameObject?.given?.[0])
        ? humanNameObject?.given?.[0]
        : '',
      middleName: !_.isUndefined(humanNameObject?.given?.[1])
        ? humanNameObject?.given?.[1]
        : '',
      lastName: !_.isUndefined(humanNameObject?.family)
        ? humanNameObject?.family
        : '',
      prefix: !_.isUndefined(humanNameObject?.prefix?.[0])
        ? _.capitalize(humanNameObject?.prefix?.[0])
        : '',
      suffix: !_.isUndefined(humanNameObject?.suffix?.[0])
        ? humanNameObject?.suffix?.[0]
        : '',
      // prefixDisplay:
      //   humanNamePrefixOptionsOptionsList?.[
      //     _.findIndex(
      //       humanNamePrefixOptionsOptionsList,
      //       o => o?.code === humanNameObject?.prefix?.[0]
      //     )
      //   ]?.display,

      // suffixDisplay:
      //   humanNameSuffixOptionsList?.[
      //     _.findIndex(
      //       humanNameSuffixOptionsList,
      //       o => o?.code === humanNameObject?.suffix?.[0]
      //     )
      //   ]?.display,
      prefixDisplay: humanNameObject?.prefix?.[0],

      suffixDisplay: humanNameObject?.suffix?.reduce((sentence, word) => {
        return sentence + ` ${word}`;
      }, ''),
    };
  } else {
    return {
      use: '', // usual | official | temp | nickname | anonymous | old | maiden
      text: '', // Text representation of the full name
      family: '', // Family name (often called 'Surname')
      given: [], // Given names (not always 'first'). Includes middle names//array
      prefixArray: [], // Parts that come before the name//array
      suffixArray: [], // Parts that come after the name//array
      period: {}, // Time period when name was/is in use
      firstName: '',
      middleName: '',
      lastName: '',
      prefix: humanNamePrefixOptionsOptionsList?.[0]?.code,
      suffix: humanNameSuffixOptionsList?.[0]?.code,
      // prefixDisplay: humanNamePrefixOptionsOptionsList?.[0]?.display,
      // suffixDisplay: humanNameSuffixOptionsList?.[0]?.display
      prefixDisplay: '',
      suffixDisplay: '',
    };
  }
};

export const addressInitialStateFromFhirAddressObject = (
  addressObject,
  addressType
) => {
  /**
   * @param addressType takes value as home, work etc
   */

  addressObject =
    addressObject?.[_.findIndex(addressObject, o => o?.use === addressType)];

  return {
    use: addressObject?.use, // home | work | temp | old | billing - purpose of this address
    type: addressObject?.type, // postal | physical | both
    text: addressObject?.text, // Text representation of the address
    addressLine1: addressObject?.line?.[0], // Street name, number, direction & P.O. Box etc.
    addressLine2: addressObject?.line?.[1],
    city: addressObject?.city, // Name of city, town etc.
    district: addressObject?.district, // District name (aka county)
    state: !_.isEmpty(addressObject?.state)
      ? addressObject?.state
      : usaStateListWithCodes?.[0]?.code, // Sub-unit of country (abbreviations ok)
    postalCode: addressObject?.postalCode, // Postal code for area
    country: !_.isEmpty(addressObject?.country)
      ? addressObject?.country
      : 'usa', // Country (e.g. can be ISO 3166 2 or 3 letter code)
  };
};

export const telecomInitialStateFromTelecomObject = telecomArr => {
  let phoneNumber =
    telecomArr?.[
      _.findIndex(telecomArr, o => {
        return o?.system === 'phone' && o?.use === 'home';
      })
    ]?.value;

  let mobileNumber =
    telecomArr?.[
      _.findIndex(telecomArr, o => {
        return o?.system === 'phone' && o?.use === 'mobile';
      })
    ]?.value;

  let email =
    telecomArr?.[
      _.findIndex(telecomArr, o => {
        return o?.system === 'email' && o?.use === 'home';
      })
    ]?.value;

  return {
    phoneNumber,
    mobileNumber,
    email,
  };
};

export const telecomInitialStateFromTelecomObjectMyLocation = telecomArr => {
  let phoneNumber =
    telecomArr?.[
      _.findIndex(telecomArr, o => {
        return o?.system === 'phone' && o?.use === 'home';
      })
    ]?.value;

  let mobileNumber =
    telecomArr?.[
      _.findIndex(telecomArr, o => {
        return o?.system === 'phone' && o?.use === 'mobile';
      })
    ]?.value;

  let email =
    telecomArr?.[
      _.findIndex(telecomArr, o => {
        return o?.system === 'email';
      })
    ]?.value;

  return {
    phoneNumber,
    mobileNumber,
    email,
  };
};
